import { Component, ElementRef, OnInit } from '@angular/core';
import {ProductModel} from '../../models/product.model';
import { ProductCategoryService } from '../../services/product-category.service';


@Component({
  selector: 'app-product-type-details',
  templateUrl: './product-type-details.component.html',
  styleUrls: ['./product-type-details.component.css']
})
export class ProductTypeDetailsComponent implements OnInit  {
  product: ProductModel = new ProductModel();
  fullImagePath: string;
  shouldStick: Boolean = false;
  iscommercial = 'false';
  productClass: string = null;
  constructor(private service: ProductCategoryService, private hostElement: ElementRef) { this.bingScrollEvent(); }

  async ngOnInit() {
    const prodTypeAtt = this.hostElement.nativeElement.getAttributeNode('product-type');
    const prodTypeId: string = prodTypeAtt && prodTypeAtt.value ? prodTypeAtt.value : '';

    const lineAtt = this.hostElement.nativeElement.getAttributeNode('iscommercial');
    this.iscommercial = lineAtt && lineAtt.value ? lineAtt.value : 'false';

    const classAtt = this.hostElement.nativeElement.getAttributeNode('productClass');
    this.productClass = classAtt && classAtt.value ? classAtt.value : null;

    this.product = await this.getproductbyId(prodTypeId);
    this.product.iscommercial = this.iscommercial == 'true';

    // If resendential and product only in one line use default swap fields
    if (this.product.iscommercial === false && this.product.line.length === 1) {
      this.product.resDescription = this.product.resDescription === '' ? this.product.description : this.product.resDescription;
      this.product.resOverview = this.product.resOverview === '' ? this.product.overview : this.product.resOverview;
      this.product.resBenefitsFeatures = this.product.resBenefitsFeatures === '' ? this.product.benefitsFeatures : this.product.resBenefitsFeatures;
    }
    this.fullImagePath = '/angular/dist/assets/Locater.svg';
  }


  async getproductbyId(Id?: string): Promise<ProductModel> {
    let result: ProductModel = new ProductModel();
    await this.service.getPartialProductById(Id)
    .then(
      res => {
      if (res) {
        let retproduct: any;
        retproduct = res as any;
        result =  retproduct ? new ProductModel(retproduct) : new ProductModel();
        return result;
      }
    }
  ).catch(err => console.log(err));
    return result;
  }

  bingScrollEvent() {
    window.addEventListener('scroll', () => {
        this.shouldStick = window.pageYOffset > 400;
    });
}

  hasRelatedProducts(): boolean {
    const hasRelated = this.product && this.product.relatedProducts && this.product.relatedProducts.length > 0;
    if(! hasRelated ) {
      return false;
    }
    for(const prod of this.product.relatedProducts) {
      if(prod.shouldDisplay(this.iscommercial, this.productClass)) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/containers/product-type-details/product-type-details.component.ts